import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }
const _hoisted_5 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spending_summary = _resolveComponent("spending-summary")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_delete_button = _resolveComponent("delete-button")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isEditable && _ctx.rowIds.length > 0)
      ? (_openBlock(), _createBlock(_component_spending_summary, {
          key: 0,
          "table-data": _ctx.tableData,
          onFilterTableEmit: _ctx.filterTable
        }, null, 8, ["table-data", "onFilterTableEmit"]))
      : _createCommentVNode("", true),
    (_ctx.tableData && _ctx.tableData.length > 0)
      ? (_openBlock(), _createBlock(_component_v_container, {
          key: 1,
          class: "tw-mt-4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_table, { density: "compact" }, {
              default: _withCtx(() => [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableContents.headers, (header, index) => {
                      return (_openBlock(), _createElementBlock("th", { key: index }, _toDisplayString(header), 1))
                    }), 128))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (row, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: index,
                      class: _normalizeClass(
            row.category === 'Unknown' || row.BCJL === 'Unknown'
              ? 'tw-bg-rose-100'
              : null
          )
                    }, [
                      (!_ctx.hideRows[index])
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("td", null, _toDisplayString(_ctx.isEditable
                  ? _ctx.firebaseDateToString(row.fullDate)
                  : _ctx.dateToString(row.fullDate)), 1),
                            _createElementVNode("td", null, _toDisplayString(row.desc), 1),
                            _createElementVNode("td", null, _toDisplayString(Number(row.amount).toFixed(2)), 1),
                            (_ctx.isEditable && _ctx.rowIds)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_1, [
                                  _createVNode(_component_v_select, {
                                    items: 
                  row.amount > 0
                    ? _ctx.tableContents.category.amtPos
                    : _ctx.tableContents.category.amtNeg
                ,
                                    class: "tw-m-auto",
                                    modelValue: row.category,
                                    "onUpdate:modelValue": [($event: any) => ((row.category) = $event), ($event: any) => (
                  _ctx.updateCategory(row.category, _ctx.rowIds[index])
                )],
                                    density: "compact"
                                  }, null, 8, ["items", "modelValue", "onUpdate:modelValue"])
                                ]))
                              : (_openBlock(), _createElementBlock("td", _hoisted_2, _toDisplayString(row.category), 1)),
                            (_ctx.isEditable && _ctx.rowIds)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_3, [
                                  _createVNode(_component_v_select, {
                                    items: _ctx.tableContents.BCJL,
                                    modelValue: row.BCJL,
                                    "onUpdate:modelValue": [($event: any) => ((row.BCJL) = $event), ($event: any) => (_ctx.updateBCJL(row.BCJL, _ctx.rowIds[index]))],
                                    density: "compact"
                                  }, null, 8, ["items", "modelValue", "onUpdate:modelValue"])
                                ]))
                              : (_openBlock(), _createElementBlock("td", _hoisted_4, _toDisplayString(row.BCJL), 1)),
                            _createElementVNode("td", null, _toDisplayString(row.bank), 1),
                            (_ctx.isEditable && _ctx.rowIds)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_5, [
                                  _createVNode(_component_v_btn, {
                                    type: "button",
                                    onClick: ($event: any) => (_ctx.deleteRow(index)),
                                    elevation: "0"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_delete_button)
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 2))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}